import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/store'

// 创建axios实例
const request = axios.create({
  baseURL: '/api',
  timeout: 30000
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const userStore = useUserStore()
    if (userStore.token) {
      config.headers.Authorization = `Bearer ${userStore.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data
    
    if (res.code !== 200) {
      ElMessage.error(res.message || '请求失败')
      
      // 401未授权，清除token并跳转到登录页
      if (res.code === 401) {
        const userStore = useUserStore()
        userStore.logout()
        window.location.href = '/#/login'
      }
      
      return Promise.reject(new Error(res.message))
    }
    
    return res
  },
  (error) => {
    // P0-18: 409撞单检测，返回响应数据让业务代码处理
    if (error.response?.status === 409) {
      return error.response.data
    }
    // P0-19: 423账号锁定，显示具体信息
    if (error.response?.status === 423) {
      ElMessage.error(error.response.data?.message || '账号已锁定')
      return Promise.reject(error)
    }
    ElMessage.error(error.response?.data?.message || error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default request
